import type { FC } from "react";
import { memo, useEffect } from "react";

import type { IButton } from "@Components/Button";
import useAjax from "@Components/Hooks/useAjax";
import { Modal } from "@Components/Modal";

import { ButtonsBar } from "./ButtonsBar";

import * as css from "./ConfirmationModal.module.css";

export interface IConfirmationModal {
    headerText: string;
    text?: string;
    nextButton?: IButton;
    cancelButton?: IButton;
    onClose?: () => void;
    children?: any;
    ajaxTrackAction?: string;
}

const ConfirmationModal: FC<IConfirmationModal> = memo((props) => {
    const { request } = useAjax<void>({ ajaxAction: props.ajaxTrackAction });
    useEffect(() => {
        if (props.ajaxTrackAction) {
            request();
        }
    }, []);

    return (
        <Modal
            className={css.confirmationModalComponent}
            headerText={props.headerText}
            onClose={props.onClose}
            isOpen
            hideCloseButton
        >
            {props.text ? (
                <div className={css.confirmationText} dangerouslySetInnerHTML={{ __html: props.text }} />
            ) : (
                props.children
            )}
            <ButtonsBar nextButton={props.nextButton} cancelButton={props.cancelButton} />
        </Modal>
    );
});

export default ConfirmationModal;
